import React from 'react';
import { faCar } from '@fortawesome/pro-regular-svg-icons/faCar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CarRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCar} {...props} />;
}
